/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description custom attribute constants
 */

const CUSTOM_ATTRIBUTE_ENTITY_TYPE: Record<string, CustomAttributes.IEntityType> = {
	claim: 'Claim',
	worklist: 'Worklist',
	account: 'Account',
	patientPayment: 'PatientPayment',
	insurancePayment: 'InsurancePayment',
	patient: 'Patient',
};

const CUSTOM_ATTRIBUTE_ENTITY_TYPE_OPTIONS: { label: string; value: CustomAttributes.IEntityType }[] = [
	{ label: 'Accounts', value: 'Account' },
	{ label: 'Claims', value: 'Claim' },
	{ label: 'Insurance Payments', value: 'InsurancePayment' },
	{ label: 'Patients', value: 'Patient' },
	{ label: 'Patient Payments', value: 'PatientPayment' },
	{ label: 'Worklists', value: 'Worklist' },
];

const CUSTOM_ATTRIBUTE_FORM_FIELDS: Record<keyof CustomAttributes.IFormFields, keyof CustomAttributes.IFormFields> = {
	fieldName: 'fieldName',
	entity: 'entity',
	description: 'description',
	fieldType: 'fieldType',
	defaultBooleanValue: 'defaultBooleanValue',
	listItems: 'listItems',
};

const CUSTOM_ATTRIBUTE_FIELD_TYPE: Record<string, CustomAttributes.IFieldType> = {
	boolean: 'boolean',
	date: 'date',
	list: 'list',
	multiSelectList: 'multi_select_list',
};

const CUSTOM_ATTRIBUTE_FIELD_TYPE_OPTIONS: { label: string; value: CustomAttributes.IFieldType }[] = [
	{ label: 'Boolean', value: 'boolean' },
	{ label: 'Date', value: 'date' },
	{ label: 'Single Select', value: 'list' },
	{ label: 'Multi Select', value: 'multi_select_list' },
];

const CUSTOM_ATTRIBUTE_FORM_FIELDS_META: Record<
	keyof CustomAttributes.IFormFields,
	{
		label: string;
		placeholder?: string;
		errorMessage?: string;
	}
> = {
	fieldName: {
		label: 'Field Name',
		placeholder: 'Enter Field Name',
		errorMessage: 'Please enter a valid field name',
	},
	entity: {
		label: 'Entity',
		placeholder: 'Select Entity',
		errorMessage: 'Please select a valid entity',
	},
	description: {
		label: 'Description',
		placeholder: 'Enter Description',
	},
	fieldType: {
		label: 'Field Type',
		placeholder: 'Select Field Type',
		errorMessage: 'Please select a valid field type',
	},
	defaultBooleanValue: {
		label: 'Default Value',
	},
	listItems: {
		label: 'List Items',
	},
};

const MAX_CUSTOM_ATTRIBUTES_PER_ENTITY = 10;
const MAX_CUSTOM_FIELD_COLUMNS = 5;

export {
	CUSTOM_ATTRIBUTE_ENTITY_TYPE,
	CUSTOM_ATTRIBUTE_ENTITY_TYPE_OPTIONS,
	CUSTOM_ATTRIBUTE_FORM_FIELDS,
	CUSTOM_ATTRIBUTE_FORM_FIELDS_META,
	CUSTOM_ATTRIBUTE_FIELD_TYPE,
	CUSTOM_ATTRIBUTE_FIELD_TYPE_OPTIONS,
	MAX_CUSTOM_ATTRIBUTES_PER_ENTITY,
	MAX_CUSTOM_FIELD_COLUMNS,
};
